import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { Routes, Route, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import Header from "./components/Header/Header";
import HomeScreen from "./components/HomeScreen/HomeScreen";
import Sidebar from "./components/Sidebar/Sidebar";
import LoginScreen from "./components/LoginScreen/LoginScreen";
import "./App.css";
import WatchScreen from "./components/WatchScreen/WatchScreen";
import SearchScreen from "./components/SearchScreen/SearchScreen";
import Subscriptions from "./components/Subscriptions/Subscriptions";

const Layout = ({ children }) => {
  const [sidebar, setSidebar] = useState(false);

  const toggleSidebar = () => {
    var initial = sidebar;
    setSidebar(!initial);
  };

  return (
    <>
      <Header toggleSidebar={toggleSidebar} />
      <div className="app-container ">
        <Sidebar sidebar={sidebar} toggleSidebar={toggleSidebar} />
        <Container className="app-main">{children}</Container>
      </div>
    </>
  );
};

/**
 * @todo
 * Make a Loading Screen...
 */

const App = () => {
  const navigate = useNavigate();
  const { accessToken, loading } = useSelector((state) => state.auth);

  useEffect(() => {
    if (!loading && !accessToken) {
      navigate("/auth");
    }
  }, [accessToken, loading, navigate]);

  return (
    <Routes>
      <Route
        path="/"
        element={
          <Layout>
            <HomeScreen />
          </Layout>
        }
      />
      <Route
        path="/search/:query"
        element={
          <Layout>
            <SearchScreen />
          </Layout>
        }
      />
      <Route path="/auth" element={<LoginScreen />} />
      <Route
        path="/watch/:id"
        element={
          <Layout>
            <WatchScreen />
          </Layout>
        }
      />
      <Route
        path="/subscriptions"
        element={
          <Layout>
            <Subscriptions />
          </Layout>
        }
      />
    </Routes>
  );
};

export default App;
